import { useState, useEffect } from 'react'
import '../styles/AdminForm.css'

const AdminForm = ({ mode, initialData, onSubmit, loading, token }) => {
  const isEditMode = mode === 'edit'
  const [username, setUsername] = useState('')
  const [wifeFirstname, setWifeFirstname] = useState('')
  const [wifeLastname, setWifeLastname] = useState('')
  const [husbandFirstname, setHusbandFirstname] = useState('')
  const [husbandLastname, setHusbandLastname] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [eventDate, setEventDate] = useState('')
  const [eventAddress, setEventAddress] = useState('')
  const [invitationFile, setInvitationFile] = useState(null)
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [oldPassword, setOldPassword] = useState('')
  const [error, setError] = useState('')
  const [rsvpText, setRsvpText] = useState('')
  const [rsvpSecondText, setRsvpSecondText] = useState('')
  const [reminderText, setReminderText] = useState('')
  const [afterWedding, setAfterWedding] = useState('')

  useEffect(() => {
    if (isEditMode && initialData) {
      console.log('Initial data:', initialData)
      setWifeFirstname(initialData.wife_firstname)
      setWifeLastname(initialData.wife_lastname)
      setHusbandFirstname(initialData.husband_firstname)
      setHusbandLastname(initialData.husband_lastname)
      setEmail(initialData.email)
      setPhoneNumber(initialData.phone_number)
      setEventDate(initialData.event_date)
      setEventAddress(initialData.event_address)
      setRsvpText(initialData.rsvp_text || '')
      setRsvpSecondText(initialData.rsvp_second_text || '')
      setReminderText(initialData.reminder_text || '')
      setAfterWedding(initialData.after_wedding || '')
    }
  }, [initialData, isEditMode])

  const isValidPassword = (password) => {
    const strongPassRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
    return strongPassRegex.test(password)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (newPassword !== '') {
      if (!isValidPassword(newPassword)) {
        setError(
          'New password must be at least 8 characters, contain a number and a special character.'
        )
        return
      }

      if (newPassword !== confirmNewPassword) {
        setError('New passwords do not match.')
        return
      }
    }

    setError('')
    onSubmit({
      wife_firstname: wifeFirstname,
      wife_lastname: wifeLastname,
      husband_firstname: husbandFirstname,
      husband_lastname: husbandLastname,
      username,
      email,
      phone_number: phoneNumber,
      event_date: eventDate,
      event_address: eventAddress,
      invitationFile, // ✅ pass the file too!
      new_password: newPassword,
      old_password: oldPassword,
      rsvp_text: rsvpText,
      rsvp_second_text: rsvpSecondText,
      reminder_text: reminderText,
      after_wedding_text: afterWedding,
    })
  }

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Wife Firstname"
        value={wifeFirstname}
        onChange={(e) => setWifeFirstname(e.target.value)}
      />
      <input
        type="text"
        placeholder="Wife Lastname"
        value={wifeLastname}
        onChange={(e) => setWifeLastname(e.target.value)}
      />
      <input
        type="text"
        placeholder="Husband Firstname"
        value={husbandFirstname}
        onChange={(e) => setHusbandFirstname(e.target.value)}
      />
      <input
        type="text"
        placeholder="Husband Lastname"
        value={husbandLastname}
        onChange={(e) => setHusbandLastname(e.target.value)}
      />
      {!isEditMode && (
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      )}
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="text"
        placeholder="Phone Number"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />
      <input
        type="date"
        value={eventDate}
        onChange={(e) => setEventDate(e.target.value)}
      />
      <input
        type="text"
        placeholder="Event Address"
        value={eventAddress}
        onChange={(e) => setEventAddress(e.target.value)}
      />
      <div style={{ marginTop: '15px' }}>
        <p>Upload Invitation Image</p>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setInvitationFile(e.target.files[0])}
        />
      </div>
      {isEditMode && (
        <input
          type="password"
          placeholder="Old Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
      )}
      <input
        type="password"
        placeholder={isEditMode ? 'New Password' : 'Password'}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <input
        type="password"
        placeholder="Confirm Password"
        value={confirmNewPassword}
        onChange={(e) => setConfirmNewPassword(e.target.value)}
      />

      <div className="message-input-container">
        <label>First RSVP message</label>
        <textarea
          placeholder="First RSVP message to send to guests"
          value={rsvpText}
          onChange={(e) => setRsvpText(e.target.value)}
          rows={4}
        />
      </div>

      <div className="message-input-container">
        <label>Reminder RSVP message</label>
        <textarea
          placeholder="Reminder RSVP message to send to guests"
          value={rsvpSecondText}
          onChange={(e) => setRsvpSecondText(e.target.value)}
          rows={4}
        />
      </div>

      <div className="message-input-container">
        <label>General reminder text</label>
        <textarea
          placeholder="General reminder message that can be sent as needed"
          value={reminderText}
          onChange={(e) => setReminderText(e.target.value)}
          rows={4}
        />
      </div>

      <div className="message-input-container">
        <label>After-Wedding thank-you</label>
        <textarea
          placeholder="After-Wedding thank-you message to send to guests"
          value={afterWedding}
          onChange={(e) => setAfterWedding(e.target.value)}
          rows={4}
        />
      </div>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <button type="submit" disabled={loading}>
        {loading ? 'Saving...' : isEditMode ? 'Save Changes' : 'Register'}
      </button>
    </form>
  )
}

export default AdminForm
